export default __webpack_public_path__ + "static/media/g.36f5122f.mp4";